export const LINKING_FEATURES_CARD_OPTIONS = { allowDatasource: true };
export const IS_UPLOAD_MEDIA_CONFIG_REQUIRED = true;
